import validate from "/work/node_modules/nuxt/dist/pages/runtime/validate.js";
import profile_45completion_45global from "/work/middleware/profile-completion.global.ts";
import manifest_45route_45rule from "/work/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  profile_45completion_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}